import * as React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

const Checkbox = React.forwardRef(({ className, checked, onCheckedChange, defaultChecked, ...props }, ref) => {
  const isControlled = checked !== undefined;
  const [internalChecked, setInternalChecked] = React.useState(Boolean(defaultChecked));
  const isChecked = isControlled ? Boolean(checked) : internalChecked;

  const handleChange = (e) => {
    if (!isControlled) setInternalChecked(e.target.checked);
    onCheckedChange?.(e.target.checked);
  };

  return (
    <label className={cn('relative inline-flex cursor-pointer items-center', className)}>
      <input
        ref={ref}
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        className="sr-only peer"
        defaultChecked={defaultChecked}
        {...props}
      />
      <span
        className={cn(
          'flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border ring-offset-2 transition-colors',
          'border-border-light bg-background-secondary peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-offset-background-primary',
          'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
          isChecked && 'border-primary-500 bg-primary-500 text-primary-900'
        )}
      >
        {isChecked ? <Check className="h-3 w-3" strokeWidth={3} /> : null}
      </span>
    </label>
  );
});
Checkbox.displayName = 'Checkbox';

export { Checkbox };
